import React from 'react'
import { connect } from 'react-redux'
import AttractionPromoActions from '../../Redux/AttractionPromoRedux'
import FileUploader from '../../Containers/FileUploader'

class Image extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        country_id: props.detail.country_id,
        image_file: undefined
      }
    }
  }

  _fileUploaded = (filename) => {
    let form = { ...this.state.form }
    form.image_file = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let uuid = this.props.detail.id
    let form = { ...this.state.form }
    const data = { uuid, form }
    this.props.put(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw' }}>
        <header className='title-block'>
          <h1 className='title'>
            Edit Attraction Promo Image
            <small className='form-text text-muted'>{this.props.detail.name}</small>
          </h1>
        </header>
        <form onSubmit={(event) => this._submit(event)}>
          {
            this.props.detail.image_file &&
            <div className='form-group text-center'>
              <label className='control-label'>Current Image</label>
              <br />
              <img
                alt={this.props.detail.image_file}
                title={this.props.detail.image_file}
                className='img img-responsive img-border'
                style={{ maxWidth: '65vw', maxHeight: '65vh' }}
                src={this.props.detail.image_url}
              />
            </div>
          }
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image File (<span className='text-orange'>155x155</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader
                setting={{ type: 'attraction-promo' }}
                onUploaded={(filename) => this._fileUploaded(filename)}
              />
            </div>
          </div>
          <div className='form-group d-flex justify-content-end'>
            <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}> Cancel</button>
            <button className='btn btn-lg btn-primary' type='submit'>Submit</button>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  put: (data) => dispatch(AttractionPromoActions.putAttractionPromoRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Image)



// WEBPACK FOOTER //
// ./src/Containers/AttractionPromo/Image.js